<template>
  <div id="app">
    <!-- <router-view /> -->
    <home />
    <link rel="stylesheet" href="//at.alicdn.com/t/font_2451091_bbjfsbjg2lm.css" />
  </div>
</template>

<script>
import home from "./components/home.vue";
import ele from "./style/ele.css";
import main from "./style/main.css";
export default {
  components: { home },
  name: "App",
  methods: {},
  mounted() {
    document.oncontextmenu = function () {
      // 　　return false;
    };
  },
};
</script>

<style>
.el-form-item {
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue